import type { HTMLAttributes } from "react";

export type BadgeVariant =
  | "tint"
  | "success"
  | "warning"
  | "danger"
  | "neutral"
  | "neutralBg";
export type BadgeSize = "xs" | "sm" | "md";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
}

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  tint: "tint",
  success: "success",
  warning: "warning",
  danger: "danger",
  neutral: "neutral",
  neutralBg: "neutral-bg",
};

export function Badge({
  variant = "tint",
  size = "sm",
  className,
  children,
  ...rest
}: BadgeProps) {
  const classes = [
    "ds-badge",
    `ds-badge--${VARIANT_CLASS[variant]}`,
    `ds-badge--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}
